<template>
  <div>
    <div v-if="!USERMANAGER.isStudent && showAnyActionItems">
      <span :class="getStatusClass()" v-if="statusValue == 6">{{statusText}}</span>
      <el-dropdown @command="handleCommand" v-else>
        <span :class="getStatusClass()">
          {{statusText}}<img :src="iconSrc"/>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="showActionItem1" :command="6">取消预约</el-dropdown-item>
          <el-dropdown-item v-if="showActionItem2" :command="4" :disabled="isClosed">通过审核</el-dropdown-item>
          <el-dropdown-item v-if="showActionItem3" :command="5">未通过</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-else class="cs-studentApp-wrapper">
      <span :class="getStatusClass()">{{statusText}}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.el-dropdown {
  .el-dropdown-link {
    img {
      height: 1rem;
      padding-left: 1rem;
    }
  }
}
.cs-appointment-green {
  color: #009145;
}
.cs-appointment-red {
  color: #e1272d;
}
.cs-studentApp-wrapper{
  .cs-app-status-label{
    display: block;
  }
  .el-button{
    display: block;
    margin-left:0;
    margin-top:5px;
  }
}
</style>

<script>
import {
  cancelVideoAppointment,
} from "../../../service/videoAppointment.service";
import global_ from "../../../core/global";

export default {
  props: {
    data: {},
    columnData: {},
    status: {}
  },
  data() {
    return {
      statusValue: 0,
      statusText: "",
      isRefunded: false,
      isClosed: false,
      btnDisabled: false,
      iconSrc: require("../../../assets/icon-dropdown.png")
    };
  },
  components: {},
  created() {
    this.init();
  },
  computed: {
    showActionItem1() {
      return this.statusValue != 6;
    },
    showActionItem2() {
      return this.statusValue == 3;
    },
    showActionItem3() {
      return this.statusValue == 3;
    },
    showAnyActionItems() {
      return this.showActionItem1 || this.showActionItem2 || this.showActionItem3;
    }
  },
  methods: {
    init() {
      if (!!this.data) {
        this.statusValue = this.data.Status;
        this.statusText = this.data.StatusString;
        this.isRefunded = this.data.IsRefunded;
        this.isClosed = this.data.IsClosed;
      }
    },
    getStatusClass() {
      let cls = "";
      if (!!this.data) {
        if (
          this.data.IsWorkflowCompleted &&
          (this.data.Status == 1 ||
          this.data.Status == 2 ||
          this.data.Status == 4)
        ) {
          cls = "cs-appointment-green";
        } else {
          cls = "cs-appointment-red";
        }
      }
      if (!this.USERMANAGER.isStudent) {
        cls += " el-dropdown-link";
      }

      return cls + " cs-app-status-label";
    },
    handleCommand(command){
      this.changeStatus(command);
    },
    changeStatus(status){
      let data = {
        name: "changeStatus",
        id: this.data.Id,
        status: status
      };
      this.$emit("customEvent", data);
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/appointmentStatusCell.vue